<template>
    <div class="create-order">
        <Form @submit="createOrder">
            <div class="row">
                <div class="col-md-8" ref="orderDetailsContainer">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between align-items-center py-2">
                            <div>Order Details</div>
                            <a href="javascript:void(0)" @click="goBack" class="cursor-pointer text-theme"><i class="bi bi-arrow-left pe-1"></i> Back</a>
                        </div>
                        <div class="card-body">
                            <div class="row g-3">
                                <div class="col-md-6">
                                    <label for="user" class="form-label">Customer</label>
                                    <input type="text" class="form-control" disabled readonly v-model="orderDetails.customer_full_name">
                                </div>
                                <template v-if="businessOrIndividual === 'business'">
                                    <div class="col-md-6">
                                        <label for="contact_person" class="form-label">Business Contact Person</label>
                                        <VueSelect
                                            v-model="orderDetails.business_contact_person_id"
                                            :items="contactPersonOptions"
                                            :placeholder="'Select Contact Person'"
                                            :searchable="false"
                                            :disabled="true"
                                        ></VueSelect>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="contact_person" class="form-label">Billing Address</label>
                                        <input
                                            class="form-control"
                                            disabled
                                            readonly
                                            :value="order.business_billing_address"
                                        />
                                    </div>
                                </template>

                                <div class="col-md-6">
                                    <label for="address" class="form-label">Service Address</label>
                                    <div class="input-group">
                                        <input
                                            class="form-control"
                                            disabled
                                            readonly
                                            :value="addressOptions.find(address => address.id === orderDetails.address_id)?.name"
                                        />
                                        <span
                                            class="input-group-text cursor-pointer"
                                            @click="copyToClipboard(addressOptions.find(address => address.id === orderDetails.address_id)?.name)"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                        </span>
                                    </div>
                                </div>
                                <template v-if="businessOrIndividual === 'business'">
                                    <div class="col-md-6">
                                        <label for="address" class="form-label">Contact Person</label>
                                        <VueSelect
                                            v-model="orderDetails.address_contact_person_id"
                                            :items="businessAddressContactPersonOptions"
                                            :placeholder="'Select Contact Person'"
                                            :searchable="false"
                                            :disabled="true"
                                        ></VueSelect>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Agency Contact Number</label>
                                        <div class="input-group">
                                            <input class="form-control" disabled readonly :value="orderDetails.customer_phone_number"/>
                                            <span
                                                class="input-group-text cursor-pointer"
                                                @click="copyToClipboard(orderDetails.customer_phone_number)"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                            </span>
                                        </div>
                                    </div>
                                </template>

                                <div :class="[businessOrIndividual === 'business' ? 'col-md-6' : 'col-md-6']">
                                    <label class="form-label">Contact Number</label>
                                    <div class="input-group">
                                        <input
                                            class="form-control"
                                            disabled
                                            readonly
                                            :value="orderDetails?.address?.contact_persons.length > 0
                                            ? orderDetails?.address?.contact_persons.map(contactPerson => contactPerson.phone_number).join(', ')
                                            : orderDetails.customer_phone_number"
                                        />
                                        <span
                                            class="input-group-text cursor-pointer"
                                            @click="copyToClipboard(orderDetails?.address?.contact_persons.length > 0 ? orderDetails?.address?.contact_persons.map(contactPerson => contactPerson.phone_number).join(', ') : orderDetails.customer_phone_number)"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                        </span>
                                    </div>
                                </div>
                            <!-- </div>
                            <div class="row mt-1 g-3"> -->
                                <div class="col-md-3">
                                    <label for="order_date" class="form-label">Service Date</label>
                                    <input
                                        readonly
                                        name="order_date"
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter event date"
                                        v-model="order.booking_date"
                                        :min="minDate"
                                        :class="{'is-invalid':!isValidated && order.booking_date === ''}"
                                    />

                                    <div class="is-invalid invalid-feedback">Order date is required.</div>
                                </div>
                                <div class="col-md-3">
                                    <label for="order_time" class="form-label">Service Time</label>
                                    <input
                                        readonly
                                        name="order_time"
                                        type="time"
                                        class="form-control"
                                        placeholder="Enter event time"
                                        v-model="order.booking_time"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="order_priority" class="form-label">Service Priority</label>
                                    <VueSelect
                                        v-model="orderDetails.order_priority"
                                        :items="[{id: '0', name: 'Due'}, {id: 1, name: 'Emergency'}, {id: 2, name: 'High'}, {id: 3, name: 'Medium'}, {id: 4, name: 'Low'}]"
                                        :placeholder="'Select Priority'"
                                        :searchable="false"
                                        :disabled="true"
                                    ></VueSelect>
                                </div>
                                <div class="col-md-6">
                                    <label for="assign_handyman" class="form-label">Task Assign to</label>
                                    <VueSelect
                                        v-model="order.handyman_id"
                                        :items="handymanList"
                                        :multiple="true"
                                        :placeholder="'Select Handyman'"
                                    ></VueSelect>
                                </div>
                                <div class="col-md-6">
                                    <label for="access_arrangement" class="form-label">Access Arrangement</label>
                                    <textarea class="form-control" id="access_arrangement" v-model="orderDetails.access_arrangement" rows="2" placeholder="Enter Access Arrangement"></textarea>
                                </div>
                                <div class="col-md-6">
                                    <label for="special_note" class="form-label">Special Note (For Handyman)</label>
                                    <textarea class="form-control" id="special_note" v-model="orderDetails.special_note" rows="2" placeholder="Enter Special Note"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center py-2">
                                    <div>Service & Pricing</div>
                                    <a
                                        href="javascript:void(0)"
                                        class="text-theme"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-title="Add More Service"
                                        @click="addMoreServiceItem"
                                    >
                                        <i class="bi bi-plus-circle"></i> Add More
                                    </a>
                                </div>
                                <div class="card-body">
                                    <table class="table in-table align-middle" id="mannualProduct">
                                        <thead>
                                            <tr>
                                                <!-- <th scope="col" width="5%">S.No</th> -->
                                                <!-- <th scope="col" width="15%">Service Type</th> -->
                                                <th scope="col" width="50%">
                                                    Service Name
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="15%"
                                                    class="text-center"
                                                >
                                                    Item Cost
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="15%"
                                                    class="text-center"
                                                >
                                                    Labour Cost
                                                </th>
                                                <!-- <th scope="col">Quantity</th> -->
                                                <!-- <th
                                                    scope="col"
                                                    width="15%"
                                                    class="text-center"
                                                >
                                                    Discount(%)
                                                </th> -->
                                                <!-- <th scope="col">VAT (in %)</th> -->
                                                <th
                                                    scope="col"
                                                    width="15%"
                                                    class="text-center"
                                                >
                                                    Total
                                                </th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(item, index) in totalServiceItems"
                                                :key="item"
                                            >
                                                <!-- <td>{{ item }}</td> -->
                                                <!-- <td>
                                                    <Select2
                                                        v-model="order.services[item - 1].service_type"
                                                        :options="serviceTypes"
                                                        :settings="{minimumResultsForSearch:'Infinity',placeholder: 'Service Type'}"
                                                        :class="{'is-invalid':!isValidated && order.services[item - 1].service_type === ''}"
                                                    />
                                                    <div class="is-invalid invalid-feedback">
                                                        This field is required.
                                                    </div>
                                                </td> -->
                                                <td>
                                                    <!-- If selected service_type is service then show service list -->
                                                    <template v-if="order.services[item - 1].service_type === 'service'">
                                                        <!-- <Select2
                                                            v-model="order.services[item - 1].service_id"
                                                            :options="serviceOptions"
                                                            :settings="{minimumResultsForSearch:'Infinity',placeholder:'Select Service'}"
                                                            @select="calculateServiceItemAmount('service',item - 1)"
                                                            :class="{'is-invalid':!isValidated && order.services[item - 1].service_id === ''}"
                                                        /> -->
                                                        <vue-multiselect
                                                            v-model="order.services[item - 1].select_service"
                                                            :class="{ 'is-invalid': !isValidated && order.services[item - 1].select_service==null }"
                                                            :options="serviceOptionList(index)"
                                                            placeholder="Search or add new service"
                                                            tag-placeholder="Add this as new service"
                                                            :taggable="true"
                                                            :show-labels="true"
                                                            track-by="name"
                                                            label="name"
                                                            @tag="addNewService($event,index)"
                                                            @select="selectService($event,index)"
                                                        ></vue-multiselect>
                                                        <div class="is-invalid invalid-feedback">
                                                            This field is required.
                                                        </div>
                                                    </template>
                                                    <template v-else-if="order.services[item - 1].service_type === 'package'">
                                                        <!-- If selected service_type is package then show package list -->
                                                        <Select2
                                                            v-model="order.services[item - 1].package_id"
                                                            :options="packageOptions"
                                                            :settings="{minimumResultsForSearch:'Infinity', placeholder:'Select Package'}"
                                                            @select="calculateServiceItemAmount('package',item - 1)"
                                                            :class="{'is-invalid':!isValidated && order.services[item - 1].package_id === ''}"
                                                        />
                                                        <div class="is-invalid invalid-feedback">
                                                            This field is required.
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <Select2
                                                            :options="[{id: ' ',text: 'Select Service'}]"
                                                            :settings="{minimumResultsForSearch:'Infinity',placeholder:'Select Service'}"
                                                            :class="{'is-invalid':!isValidated && order.services[item - 1].service_id === ''}"
                                                        />
                                                        <div class="is-invalid invalid-feedback">
                                                            This field is required.
                                                        </div>
                                                    </template>
                                                </td>
                                                <td class="text-center">
                                                    <input
                                                        type="text"
                                                        name="amount"
                                                        class="form-control"
                                                        placeholder="Item price"
                                                        v-model="
                                                            order.services[item - 1]
                                                                .amount
                                                        "
                                                        @keypress="allowNumbersOnly"
                                                        @keydown="handleSpecialKeys"
                                                        :class="{'is-invalid':!isValidated && order.services[item - 1].amount === ''}"
                                                    />
                                                    <div class="is-invalid invalid-feedback">
                                                        This field is required.
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <input
                                                        type="text"
                                                        name="labour_cost"
                                                        class="form-control"
                                                        placeholder="Labour charge"
                                                        v-model="
                                                            order.services[item - 1]
                                                                .labour_cost
                                                        "
                                                        @keypress="allowNumbersOnly"
                                                        @keydown="handleSpecialKeys"
                                                        :class="{
                                                            'is-invalid':
                                                                !isValidated &&
                                                                order.services[item - 1]
                                                                    .labour_cost === '',
                                                        }"
                                                    />
                                                    <div
                                                        class="is-invalid invalid-feedback"
                                                    >
                                                        This field is required.
                                                    </div>
                                                </td>
                                                <!-- <td class="text-center">
                                                    <input
                                                        type="text"
                                                        name="discount"
                                                        class="form-control"
                                                        placeholder="Enter discount percentage"
                                                        v-model="
                                                            order.services[item - 1]
                                                                .discount
                                                        "
                                                        @input="
                                                            validateInput(
                                                                'service',
                                                                item - 1
                                                            )
                                                        "
                                                        @keypress="allowNumbersOnly"
                                                        @keydown="handleSpecialKeys"
                                                    />
                                                </td> -->
                                                <td class="text-center">
                                                    £{{
                                                        order.services[item - 1]
                                                            .total_amount
                                                    }}
                                                </td>
                                                <td class="text-center">
                                                <button
                                                    v-if="
                                                        Object.keys(
                                                            order.services
                                                        ).length > 1 && order.services[item - 1]
                                                            .recurring_services != '1'
                                                    "
                                                    type="button"
                                                    class="btn btn-sm btn-danger"
                                                    @click="removeOrderItem(item - 1)"
                                                    style="left: 30px"
                                                >
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center py-2">
                                    Comment & Attachment
                                </div>
                                <div class="card-body">
                                    <div class="row g-3">
                                        <div class="col-md-12">
                                            <label for="comment" class="form-label">Comment</label>
                                            <textarea
                                                class="form-control"
                                                id="comment"
                                                v-model="order.comment"
                                                rows="2"
                                                placeholder="Enter comment"
                                            ></textarea>
                                        </div>
                                        <div v-if="orderDetails.order_images && orderDetails.order_images.length" class="col-md-12 d-flex flex-wrap pt-2">
                                            <div
                                                v-for="(orderImage, index) in orderDetails.order_images"
                                                :key="orderImage.id"
                                                class="position-relative me-2 mb-2"
                                            >
                                                <a
                                                    :href="`${$s3RootUrl}/order/${orderImage.file_name}`"
                                                    :class="{
                                                        'order-img-slides': ['image', 'video', 'pdf'].includes(orderImage.file_type),
                                                    }"
                                                >
                                                    <img
                                                        :src="prepareImageSource(orderImage)"
                                                        class="img-thumbnail cursor-pointer"
                                                        :alt="orderImage.name"
                                                        style="max-height: 80px; max-width: 80px;"
                                                    />
                                                </a>
                                                <span @click="removeOrderImage(orderImage)" class="position-absolute top-0 start-100 translate-middle cursor-pointer">
                                                    <i class="bi bi-x-circle-fill text-danger"></i>
                                                </span>
                                            </div>

                                        </div>

                                        <div class="col-md-12">
                                            <!-- Image uploader -->
                                            <ImageUploader ref="imageUploader" :orderId="order.id" />

                                            <!-- <label for="description" class="form-label">Attachment</label>
                                            <div class="input-group mb-3">
                                                <input
                                                    type="file"
                                                    class="form-control"
                                                    multiple
                                                    @change="onFileChange"
                                                />
                                            </div>

                                            <template v-for="file in previewUploadedFiles">
                                                <img
                                                    :src="prepareImageSource(file)"
                                                    class="img-thumbnail me-2 mb-2"
                                                    style="{max-height: 150px;max-width: 150px;}"
                                                />
                                            </template> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center py-2">
                                    Calculation
                                </div>
                                <div class="card-body">
                                    <div class="row g-3">
                                        <div class="col-md-3">
                                            <label for="discount" class="form-label">Total</label>
                                            <input
                                                readonly
                                                type="text"
                                                class="form-control"
                                                v-model="order.amount"
                                            />
                                        </div>
                                        <div class="col-md-3">
                                            <label for="discount" class="form-label">Discount(%)</label>
                                            <input
                                                name="discount"
                                                type="text"
                                                class="form-control"
                                                placeholder="Enter discount"
                                                v-model="order.discount"
                                                @input="validateInput('order', 1)"
                                                @keypress="allowNumbersOnly"
                                                @keydown="handleSpecialKeys"
                                            />
                                        </div>
                                        <div class="col-md-3">
                                            <label for="discount" class="form-label">Discount</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                readonly
                                                v-model="order.discount_amount"
                                            />
                                        </div>
                                        <div class="col-md-3">
                                            <label for="discount" class="form-label">Amount</label>
                                            <input
                                                readonly
                                                type="text"
                                                class="form-control"
                                                :value="(order.amount - order.discount_amount).toFixed(2)"
                                            />
                                        </div>
                                        <!-- <div
                                            class="d-flex justify-content-between align-items-center"
                                        > -->
                                            <div class="col-md-3">
                                                <label for="discount" class="form-label">VAT(%)</label>
                                                <!-- <input name="discount" type="text" class="form-control" placeholder="Enter discount" readonly v-model="tax"> -->
                                                <!-- <Select2
                                                    v-model="order.tax"
                                                    :options="[
                                                        { id: '0', text: '0' },
                                                        { id: tax, text: tax },
                                                    ]"
                                                    :settings="{
                                                        minimumResultsForSearch:
                                                            'Infinity',
                                                        placeholder: 'Select VAT',
                                                    }"
                                                /> -->
                                                <VueSelect
                                                    v-model="order.tax"
                                                    :items="[{'id': '0', 'name': '0'}, {'id': tax, 'name': tax}]"
                                                    :placeholder="'Select VAT'"
                                                    :searchable="false"
                                                ></VueSelect>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="discount" class="form-label">VAT</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    readonly
                                                    v-model="order.tax_amount"
                                                />
                                            </div>
                                            <!-- <div class="col-4">
                                                <label
                                                    for="total_amount"
                                                    class="form-label"
                                                    >Round Off
                                                    <span class="text-danger"
                                                        >(-/+)</span
                                                    ></label
                                                >
                                                <input
                                                    name="total_amount"
                                                    type="text"
                                                    class="form-control"
                                                    readonly
                                                    value="0.00"
                                                />
                                            </div> -->
                                        <!-- </div> -->
                                        <div class="col-md-3">
                                            <label for="total_amount" class="form-label">Net Price</label>
                                            <input
                                                name="total_amount"
                                                type="text"
                                                class="form-control"
                                                readonly
                                                :value="'£' + order.total_amount"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Submit button -->
                    <div class="card">
                        <div class="card-body">
                            <button
                                type="submit"
                                class="btn btn-theme btn-sm float-end"
                                v-text="isProcessing ? 'Processing...' : 'Update Order'"
                                :disabled="isProcessing || !isFormValid"
                                :class="{ disabled: isProcessing || !isFormValid }"
                            ></button>
                        </div>
                    </div>
                </div>
                <!-- Timeline -->
                <!-- Order Timeline -->
                <div class="col-md-4 ps-0">
                    <div class="main-card mb-3 card">
                        <div class="card-header d-flex justify-content-between align-items-center py-2">
                            Order Timeline
                        </div>
                        <div class="card-body dashboard">
                            <div class="scroll-area sidebar-timeline" :style="{ height: orderContainerHeight + 'px' }">
                                <div class="activity">
                                    <div
                                        v-for="(history, index) in orderDetails.order_histories"
                                        :key="index"
                                        class="activity-item d-flex"
                                    >
                                        <div class="activite-label"></div>
                                        <i class="bi bi-circle-fill activity-badge text-primary align-self-start"></i>
                                        <div class="activity-content">
                                            <h6 class="timeline-title text-capitalize">{{ (history.action_type).replace(/_/g, ' ') }}</h6>
                                            <p class="hm-fs-10 mb-1">{{this.dataTimeFormat(history.created_at, 'dddd, MMMM D, YYYY')}} at {{this.dataTimeFormat(history.created_at, 'hh:mm A')}} By {{history?.user?.first_name}}</p>
                                            <p class="mb-1" v-if="history.comment">{{ history.comment }}</p>

                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.order_images && history"
                                                class="col-md-12 d-flex flex-row flex-wrap"
                                            >
                                                <div class="image-preview-row d-flex flex-row flex-wrap">
                                                    <template v-for="(historyImg, index) in JSON.parse(history.data)?.order_images" :key="historyImg.id">
                                                        <div
                                                            class="position-relative me-2 mb-2"
                                                            v-if="!isAttachmentDeleted(historyImg.id)"
                                                        >
                                                            <a
                                                                :href="`${$s3RootUrl}/order/${historyImg.image}`"
                                                                :class="{
                                                                    'order-img-slides': ['image', 'video', 'pdf'].includes(historyImg.file_type),
                                                                }"
                                                            >
                                                                <img
                                                                    :src="prepareImageSource(historyImg)"
                                                                    class="img-thumbnail cursor-pointer"
                                                                    style="max-height: 100px; max-width: 100px;"
                                                                />
                                                            </a>
                                                            <span @click="removeOrderImage(historyImg)" class="position-absolute top-0 start-100 translate-middle cursor-pointer">
                                                                <i class="bi bi-x-circle-fill text-danger"></i>
                                                            </span>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>

                                            <!-- Display order logs -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.logs" class="col-md-12">
                                                <p v-for="(orderLog, index) in JSON.parse(history.data)?.logs" :key="index" class="mb-1">
                                                    {{ orderLog.value }}
                                                </p>
                                            </div>

                                            <!-- Check if deleted items exists in the history data -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.deleted_items" class="col-md-12">
                                                <h6 class="fw-bold fs-6 text-danger">Service Deleted</h6>
                                                <p v-for="(item, index) in JSON.parse(history.data)?.deleted_items" :key="index" class="mb-1">
                                                    Service <span class="fw-bold">{{ item.service_name }}</span> is deleted from the order.
                                                </p>
                                            </div>

                                            <!-- Check if new items exists in the history data -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.new_items" class="col-md-12">
                                                <h6 class="fw-bold fs-6 text-success pt-2">Service Added</h6>
                                                <p v-for="(item, index) in JSON.parse(history.data)?.new_items" :key="index" class="mb-1">
                                                    Service <span class="fw-bold">{{ item.service_name }}</span> is added to the order.
                                                </p>
                                            </div>

                                            <!-- Check if updated_items exists in the history data -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.updated_items" class="col-md-12">
                                                <h6 class="fw-bold fs-6 text-warning pt-2">Service Updated</h6>
                                                <p v-for="(item, index) in JSON.parse(history.data)?.updated_items" :key="index" class="mb-1">
                                                    <!-- First check if update_details exists -->
                                                    <template v-if="item.update_details">
                                                        <template v-for="(updateDetail, index) in item.update_details" :key="index">
                                                            <template v-if="updateDetail.field === 'service'">Service changed from <span class="fw-bold">{{ updateDetail.old_value }}</span> to <span class="fw-bold">{{ updateDetail.new_value }}</span>.</template>
                                                            <template v-else-if="updateDetail.field === 'price'">Item price changed from <span class="fw-bold">{{ userCurrency + '' + updateDetail.old_value }}</span> to <span class="fw-bold">{{ userCurrency + '' + updateDetail.new_value }}</span> for service {{ item.service_name }}.</template>
                                                            <template v-else-if="updateDetail.field === 'labour_cost'">Labour cost changed from <span class="fw-bold">{{ userCurrency + '' + (updateDetail.old_value || 0) }}</span> to <span class="fw-bold">{{ userCurrency + '' + (updateDetail.new_value || 0) }}</span> for service {{ item.service_name }}.</template>
                                                            <template v-else-if="updateDetail.field === 'discount_value'">Discount changed from <span class="fw-bold">{{ userCurrency + '' + (updateDetail.old_value || 0) }}</span> to <span class="fw-bold">{{ userCurrency + '' + (updateDetail.new_value || 0) }}</span> for service {{ item.service_name }}.</template>

                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        Price updated to <span class="fw-bold">{{ userCurrency + '' + item.updated_price }}</span> from <span class="fw-bold">{{ userCurrency + '' + item.old_price }}</span> for {{ item.service_name }}.
                                                    </template>
                                                </p>
                                            </div>

                                            <!-- Check if total_before_update and total_after_update exists in the history data -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.total_before_update && JSON.parse(history.data)?.total_after_update && (JSON.parse(history.data)?.total_before_update != JSON.parse(history.data)?.total_after_update)" class="col-md-12">
                                                <p class="mb-1">Price updated from : <span class="fw-bold">{{ userCurrency + '' + JSON.parse(history.data)?.total_before_update }}</span> to <span class="fw-bold">{{ userCurrency + '' + JSON.parse(history.data)?.total_after_update }}</span>.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- End activity item-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 mb-4">

                </div>
            </div>
        </Form>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div v-if="typeof orderTicket.ticket !== 'undefined' && orderTicket.ticket" class="card">
                <div class="card-body pt-0 pb-0">
                    <ticket-chat :uuid="orderTicket.ticket && orderTicket.ticket.uuid ? orderTicket.ticket.uuid : ''" :user="orderTicket.user" location="orderDetail"></ticket-chat>
                </div>
            </div>
        </div>
    </div>

    <!-- Image Preview Modal -->
    <div
        v-if="showModal"
        class="modal"
        style="
            display: block;
            position: fixed;
            z-index: 1000;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            overflow: auto;
            background-color: rgba(0, 0, 0, 0.5);
        "
    >
        <div
            class="modal-content"
            style="
                background-color: #fefefe;
                margin: 15% auto;
                padding: 20px;
                border: 1px solid #888;
                width: 80%;
                max-width: 500px;
            "
        >
            <span
                class="close"
                @click="showModal = false"
                style="
                    color: #aaa;
                    float: right;
                    font-size: 28px;
                    font-weight: bold;
                "
                >&times;</span
            >
            <img
                :src="selectedImageUrl"
                alt="Image Preview"
                style="width: 100%"
            />
        </div>
    </div>

    <!-- Display recurring services -->
    <!-- @TODO need to remove this because recurring services are now changed -->
    <div v-if="order.user_id && order.address_id" class="row d-flex justify-content-center mt-10 mb-70 d-none">
        <div class="col-md-12 mt-10">
            <div class="main-card mb-3 card">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                    Recurring Services
                </div>
                <div class="card-body">
                    <RecurringServices
                        :visible-certificate="false"
                        :order-data="{order:{customer_id: order.user_id, address_id: order.address_id}}"
                    ></RecurringServices>
                </div>
            </div>
        </div>
    </div>
    <!-- Order Timeline -->
    <div class="row d-flex justify-content-center mt-10 mb-70 d-none">
        <div class="col-md-12 mt-10">

            <div class="main-card mb-3 card">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                    Order Timeline
                </div>
                <div class="card-body">
                    <div class="scroll-area">
                        <div class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
                            <div v-for="(history, index) in orderDetails.order_histories" :key="index" class="vertical-timeline-item vertical-timeline-element">
                                <div>
                                    <span class="vertical-timeline-element-icon bounce-in">
                                        <i :class="['badge badge-dot badge-dot-xl', getClassByActionType(history.action_type)]"></i>
                                    </span>
                                    <div class="vertical-timeline-element-content bounce-in">
                                        <h4 class="timeline-title text-capitalize">{{ (history.action_type).replace(/_/g, ' ') }}</h4>
                                        <p v-if="history.comment">{{ history.comment }}</p>

                                        <span class="vertical-timeline-element-date text-black">{{this.dataTimeFormatWithoutUTC(history.created_at, 'DD/MM/YYYY')}} <br> {{ this.dataTimeFormatWithoutUTC(history.created_at, 'hh:mm A') }} <br/> <small>By {{history?.user?.first_name}}</small></span>

                                        <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.order_images && history"
                                             class="col-md-12 d-flex flex-row flex-wrap"
                                        >
                                            <div class="image-preview-row d-flex flex-row flex-wrap">
                                                <a
                                                    v-for="(historyImg, index) in JSON.parse(history.data)?.order_images"
                                                    :key="historyImg.id"
                                                    :href="`${$s3RootUrl}/order/${historyImg.image}`"
                                                    :class="{
                                                        'order-img-slides': ['image', 'video', 'pdf'].includes(historyImg.file_type),
                                                    }"
                                                >
                                                    <img
                                                        :src="prepareImageSource(historyImg)"
                                                        class="img-thumbnail me-2 mb-2 cursor-pointer"
                                                        style="max-height: 150px; max-width: 150px;"
                                                    />
                                                </a>
                                            </div>
                                        </div>

                                        <!-- Display order logs -->
                                        <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.logs" class="col-md-12">
                                            <p v-for="(orderLog, index) in JSON.parse(history.data)?.logs" :key="index" class="mb-1">
                                                {{ orderLog.value }}
                                            </p>
                                        </div>

                                        <!-- Check if deleted items exists in the history data -->
                                        <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.deleted_items" class="col-md-12">
                                            <h6 class="fw-bold fs-6 text-danger">Service Deleted</h6>
                                            <p v-for="(item, index) in JSON.parse(history.data)?.deleted_items" :key="index" class="mb-1">
                                                Service <span class="fw-bold">{{ item.service_name }}</span> is deleted from the order.
                                            </p>
                                        </div>

                                        <!-- Check if new items exists in the history data -->
                                        <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.new_items" class="col-md-12">
                                            <h6 class="fw-bold fs-6 text-success pt-2">Service Added</h6>
                                            <p v-for="(item, index) in JSON.parse(history.data)?.new_items" :key="index" class="mb-1">
                                                Service <span class="fw-bold">{{ item.service_name }}</span> is added to the order.
                                            </p>
                                        </div>

                                        <!-- Check if updated_items exists in the history data -->
                                        <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.updated_items" class="col-md-12">
                                            <h6 class="fw-bold fs-6 text-warning pt-2">Service Updated</h6>
                                            <p v-for="(item, index) in JSON.parse(history.data)?.updated_items" :key="index" class="mb-1">
                                                <!-- First check if update_details exists -->
                                                <template v-if="item.update_details">
                                                    <template v-for="(updateDetail, index) in item.update_details" :key="index">
                                                        <template v-if="updateDetail.field === 'service'">Service changed from <span class="fw-bold">{{ updateDetail.old_value }}</span> to <span class="fw-bold">{{ updateDetail.new_value }}</span>.</template>
                                                        <template v-else-if="updateDetail.field === 'price'">Item price changed from <span class="fw-bold">{{ userCurrency + '' + updateDetail.old_value }}</span> to <span class="fw-bold">{{ userCurrency + '' + updateDetail.new_value }}</span> for service {{ item.service_name }}.</template>
                                                        <template v-else-if="updateDetail.field === 'labour_cost'">Labour cost changed from <span class="fw-bold">{{ userCurrency + '' + (updateDetail.old_value || 0) }}</span> to <span class="fw-bold">{{ userCurrency + '' + (updateDetail.new_value || 0) }}</span> for service {{ item.service_name }}.</template>
                                                        <template v-else-if="updateDetail.field === 'discount_value'">Discount changed from <span class="fw-bold">{{ userCurrency + '' + (updateDetail.old_value || 0) }}</span> to <span class="fw-bold">{{ userCurrency + '' + (updateDetail.new_value || 0) }}</span> for service {{ item.service_name }}.</template>

                                                    </template>
                                                </template>
                                                <template v-else>
                                                    Price updated to <span class="fw-bold">{{ userCurrency + '' + item.updated_price }}</span> from <span class="fw-bold">{{ userCurrency + '' + item.old_price }}</span> for {{ item.service_name }}.
                                                </template>
                                            </p>
                                        </div>

                                        <!-- Check if total_before_update and total_after_update exists in the history data -->
                                        <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.total_before_update && JSON.parse(history.data)?.total_after_update && (JSON.parse(history.data)?.total_before_update != JSON.parse(history.data)?.total_after_update)" class="col-md-12">
                                            <p class="mb-1">Price updated from : <span class="fw-bold">{{ userCurrency + '' + JSON.parse(history.data)?.total_before_update }}</span> to <span class="fw-bold">{{ userCurrency + '' + JSON.parse(history.data)?.total_after_update }}</span>.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//import Select2 from './partials/Select2.vue';
import Select2 from "vue3-select2-component";
import moment from "moment";

import { Form, Field } from "vee-validate";
import * as Yup from "yup";

import TicketChat from "./TicketChat";
import RecurringServices from "./RecurringServices";
import SelectHandyman from "./partials/SelectHandyman";
import VueSelect from "./partials/VueSelect";

import { appMixin } from "../mixin/appMixin";
import ImageUploader from "./Order/ImageUploader";

export default {
    components: {
        Select2,
        Form,
        Field,
        TicketChat,
        RecurringServices,
        SelectHandyman,
        VueSelect,
        ImageUploader
    },
    emits: ["select"], // Declare custom event here
    mixins: [appMixin],
    data() {
        return {
            tax: 20,
            users: [],
            userContactPersons: [],
            addresses: [],
            businessOrIndividual: "", // business or individual
            userOptions: [{ id: " ", text: "Select User" }],
            addressOptions: [{ id: " ", text: "Select Address", name: "Select Address" }],
            contactPersonOptions: [{ id: " ", text: "Select Contact Person", name: "Select Contact Person" }],
            serviceTypes: [
                { id: "", Text: "Select" },
                { id: "service", text: "Services" },
                { id: "package", text: "Packages" },
            ],
            serviceType: "", // package or service
            services: [],
            packages: [],
            order: {
                user_id: "",
                business_contact_person: "",
                business_billing_address: "",
                address_id: "",
                address_contact_person: "",
                booking_date: "",
                booking_time: "",
                start_at: "",
                end_at: "",
                order_priority: 4,
                comment: "",
                services: [
                    {
                        service_type: "service",
                        service_id: "",
                        package_id: "",
                        tax: 20,
                        discount: "", // in percentage
                        amount: "",
                        labour_cost: "",
                        discount_amount: 0.00,
                        tax_amount: 0.00,
                        total_amount: 0.00,
                        total_with_tax: 0.00,
                        service_name: "",
                        select_service: null,
                    },
                ],
                tax: 20, // in percentage
                discount: 0,
                amount: 0.00,
                item_price: 0.00,
                labour_cost: 0.00,
                discount_amount: 0.00,
                tax_amount: 0.00,
                total_amount: 0.00,
                files: [],
                access_arrangement: "",
            },
            totalServiceItems: 1,
            selectedServices: [],
            isProcessing: false,
            isFormValid: true,
            serviceOptions: [],
            packageOptions: [],
            businessAddressContactPersonOptions: [],
            minDatetime: "",
            minDate: "",
            errors: {
                user_id: "",
                business_contact_person: "",
                business_billing_address: "",
                address_id: "",
                address_contact_person: "",
                booking_date: "",
                booking_time: "",
                services: [
                    {
                        service_type: "",
                        service_id: "",
                        package_id: "",
                        amount: "",
                        discount: "", // in percentage
                        total_amount: 0.0,
                    },
                ],
            },
            isValidated: true,
            previewUploadedFiles: [],
            orderDetails: {},
            showModal: false,
            selectedImageUrl: "",
            userCurrency: '£',
            orderImagesForSlider: [],
            orderTicket: {},
            orderContainerHeight: 600,
            handymanList: [],
        }
    },
    created() {
        this.getOrderDetails();
        this.getUsers();
        this.getServicesForOrder();

        // Set the minimum datetime to the current datetime
        this.setMinDatetime();
        this.setMinDate();
    },
    computed: {
        orderSchema() {
            return Yup.object().shape({
                user_id: Yup.string().required("User is required"),
                business_contact_person: Yup.string().required(
                    "Business Contact Person is required"
                ),
                business_billing_address: Yup.string().required(
                    "Business Billing Address is required"
                ),
                address_id: Yup.string().required("Address is required"),
                address_contact_person: Yup.string().required(
                    "Address Contact Person is required"
                ),
                booking_date: Yup.string().required("Booking Date is required"),
                booking_time: Yup.string().required("Booking Time is required"),
                services: Yup.array().of(
                    Yup.object().shape({
                        service_type: Yup.string().required(
                            "Service Type is required"
                        ),
                        service_id: Yup.string().required(
                            "Service is required"
                        ),
                        package_id: Yup.string().required(
                            "Package is required"
                        ),
                        amount: Yup.string().required("Amount is required"),
                    })
                ),
            });
        },

        parsedHistories() {
            return this.orderDetails.order_histories.map(history => {
                if (history.data) {
                    try {

                        // Parse the JSON data
                        const parsedData = JSON.parse(history.data);
                        // Return the history with parsed data
                        return { ...history, data: parsedData };
                    } catch(e) {
                        console.error("Error parsing history data", e);
                        // Return the history unmodified on error
                        return history;
                    }
                }
                return history;
            });
        },
        handymanOptions() {
            let schedules = this.$store.state.availableSchedules;

            let self = this;
            let options = [];

            // Check if date is empty then return empty array
            if (this.order.booking_date === '') {
                return [];
            }

            const dateToFind = this.$moment(this.order.booking_date).format('YYYY-MM-DD');
            const timeToFind =  this.$moment(`${dateToFind} ${this.order.booking_time}`, 'YYYY-MM-DD HH:mm:ss');

            Object.keys(schedules).forEach((handymanId) => {
                schedules[handymanId].forEach((schedule) => {
                    const startTime = this.$moment(`${schedule.schedule_date} ${schedule.start_time}`, 'YYYY-MM-DD HH:mm:ss');
                    const endTime = this.$moment(`${schedule.schedule_date} ${schedule.end_time}`, 'YYYY-MM-DD HH:mm:ss');
                    if (schedule.schedule_date === dateToFind && timeToFind.isBetween(startTime, endTime,undefined, '[]')) {
                        let exists = options.some(function(option) {
                            return option.id === schedule.handyman_id;
                        });
                        // If it doesn't exist, push the new option
                        if (!exists) {
                            options.push({
                                id: schedule.handyman_id,
                                text: schedule.full_name + ' (' + moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')',
                                name: schedule.full_name + ' (' + moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')',
                            });
                        }
                    }
                });
            });

            return options;
        },
        serviceOptionList() {
            return (currentIndex) => {
                let options = [];

                // Get selected services name
                let selectedServicesName = this.order.services
                    .map((service) => {
                        return service ? service.service_name : null;
                    })
                    .filter((service, index) => {
                        return index !== currentIndex && service !== null && service !== undefined;
                    });

                this.services.forEach((service) => {
                    options.push({
                        id: service.id,
                        name: service.name,
                        price: service.price,
                        labour_cost: service.labour_cost,
                        discount: service.discount
                    });
                });

                // filter the options based on the selected services name
                options = options.filter((option) => {
                    return !selectedServicesName.includes(option.name);
                });

                return options;
            };
        }
    },
    mounted() {
        setTimeout(() => {
            this.orderContainerHeight = this.$refs.orderDetailsContainer.offsetHeight;
        }, 3000)
    },
    methods: {
        removeOrderItem(index) {
            this.totalServiceItems--;
            this.order.services.splice(index, 1);
            this.order.services = this.order.services.filter(function(){return true;});
        },
        showImageModal(imageUrl) {
            this.selectedImageUrl = imageUrl;
            this.showModal = true;
        },
         getClassByActionType(actionType) {
            switch (actionType) {
                case 'order_created':
                    return 'badge-success';
                case 'pending':
                    return 'badge-warning';
                case 'assigned':
                case 'assigned_to_handyman':
                    return 'badge-info';
                case 'processing':
                    return 'badge-primary';
                case 'quotation':
                    return 'badge-secondary';
                case 'status_reverted':
                    return 'badge-secondary';
                default:
                    return 'badge-light';
            }
        },
        /* formatDate(date) {
            // Example implementation using moment.js
            return moment(date).format('DD/MM/YYYY');
        },

        formatTime(date) {
            // Example implementation using moment.js
            return moment(date).format('HH:MM:A');
        },
        formatDateTime(date, format) {
            return moment(date).format(format);
        }, */
        /* filters: {
            capitalize(value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            },
        }, */
        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        getOrderDetails() {
            let self = this;
            axios.get(window.location.href).then((response) => {
                self.orderDetails = response.data.order;
                const assigned_to = [];
                self.orderDetails.order_handymans.forEach((e) => {
                    assigned_to.push(e.handyman_id);
                });

                self.order.handyman_id = assigned_to;

                self.order.user_id = response.data.order.customer_id;
                self.order.comment = ''; //self.orderDetails.comment;
                self.order.discount = self.orderDetails.discount_value;
                const formattedBookingDate = moment(
                    self.orderDetails.booking_date
                ).format("YYYY-MM-DD");
                const formattedBookingTime = moment(
                    self.orderDetails.booking_date
                ).format("HH:mm"); // For 24-hour format

                self.order.booking_date = formattedBookingDate; // Make sure this is the correct path
                self.order.booking_time = formattedBookingTime; // Assign formatted time

                // Get available handyman
                self.getHandymanAvailable();

                setTimeout(() => {
                    this.getContactPersons();
                    setTimeout(() => {
                        this.getBusinessAddressContactPerson();
                        if (this.orderDetails && Array.isArray(this.orderDetails.order_items) && this.orderDetails.order_items.length > 0)
                        {
                            this.totalServiceItems = this.orderDetails.order_items?.length;

                            this.order.services = this.orderDetails.order_items.map((item) => ({
                                    service_type: item.order_item_type,
                                    service_id: item.service_id,
                                    package_id: item.service_package_id,
                                    tax: item.order_item_tax,
                                    recurring_services: item.recurring_services,
                                    discount: item.order_item_discount_value,
                                    amount: item.order_item_price,
                                    labour_cost: item.order_item_labour_cost,
                                    total_amount: item.order_item_total_amount,
                                    order_item_id: item.order_item_id,
                                    service_name: item.service_name,
                                    select_service: {
                                        id: item.service_id,
                                        name: item.service_name,
                                        price: item.order_item_price,
                                        labour_cost: item.order_item_labour_cost,
                                        discount: item.order_item_discount_value
                                    }
                                }));
                        }
                    }, 1000);
                }, 1000);

                // Check if order_images are exist and then trigger the SimpleSlider
                if (typeof this.orderDetails.order_images !== "undefined" && this.orderDetails.order_images.length > 0) {
                    self.attachImageSlider();
                }

                // Get the order ticket
                this.getOrderTicket();
            });
        },
        getUsers() {
            let self = this;
            axios.post("/admin/users/list-for-booking").then((response) => {
                self.users = response.data.users;

                // Get id and name of users and push into the userOptions
                response.data.users.forEach((user) => {
                    self.userOptions.push({
                        id: user.id,
                        text: user.name,
                    });
                });
            });
        },
        // Get user contact persona and address
        getContactPersons() {
            let self = this;

            // Check if user_id is empty then no need to call the API
            // Check if user_id is empty then no need to call the API
            if (self?.orderDetails?.customer_id) {
                self.userContactPersons = [];
                self.addresses = [];
                self.businessOrIndividual = "";
                self.order.business_billing_address = "";
                // return false;
            }

            // Call the API to get user contact persona and address
            axios
                .post("/admin/users/contact-persons-and-address", {
                    user_id: self.orderDetails.customer_id,
                    status: "all",
                })
                .then((response) => {
                    self.userContactPersons = response.data.contact_persons;
                    self.addresses = response.data.addresses;
                    self.businessOrIndividual = response.data.user.account_type;

                    // Prepare the contact person options
                    self.contactPersonOptions = [
                        { id: " ", text: "Select Contact Person", name: "Select Contact Person" },
                    ];
                    response.data.contact_persons.forEach((contactPerson) => {
                        self.contactPersonOptions.push({
                            id: contactPerson.id,
                            text: contactPerson.full_name,
                            name: contactPerson.full_name,
                        });
                    });

                    // Prepare the address options
                    self.addressOptions = [{ id: " ", text: "Select Address" }];
                    response.data.addresses.forEach((address) => {
                        self.addressOptions.push({
                            id: address.id,
                            text: address.full_address,
                            name: address.full_address,
                        });
                    });

                    // Prefill the business billing address
                    if (self.orderDetails) {
                        self.order.business_billing_address =
                            self.orderDetails.billing_address;
                    } else {
                        self.order.business_billing_address =
                            response.data.billing_address;
                    }

                    // If there is only one address then set it as default
                    if (self.addresses.length == 1) {
                        self.order.address_id = self.addresses[0].id;
                    }

                    // Check if business contact person is a only one then set it as default
                    if (self.userContactPersons.length == 1) {
                        self.order.business_contact_person =
                            self.userContactPersons[0].id;
                    }
                });
        },
        getBusinessAddressContactPerson() {
            if (this.businessOrIndividual === "business") {
                let self = this;

                // Call the API to get user contact persona and address
                axios
                    .post("/admin/users/business-contact-persons", {
                        user_id: self.order.user_id,
                        address_id: self.orderDetails.address_id,
                    })
                    .then((response) => {
                        self.businessAddressContactPersonOptions = [
                            { id: " ", text: "Select Contact Person", name: "Select Contact Person" },
                        ];
                        response.data.users.forEach((user) => {
                            self.businessAddressContactPersonOptions.push({
                                id: user.id,
                                text: user.full_name,
                                name: user.full_name,
                            });
                        });
                    });
            }
        },
        getServicesForOrder() {
            let self = this;
            axios
                .post("/admin/services/get-services-for-order", {})
                .then((response) => {
                    self.services = response.data.services;
                    self.packages = response.data.packages;

                    // Prepare service options
                    self.serviceOptions = [{id: '', name: 'Select Service', price: '', labour_cost: '', discount: ''}];
                    response.data.services.forEach((service) => {
                        self.serviceOptions.push({
                            id: service.id,
                            name: service.name,
                            price: service.price,
                            labour_cost: service.labour_cost,
                            discount: service.discount
                        });
                    });

                    // Prepare package options
                    self.packageOptions = [{ id: " ", text: "Select Package" }];
                    response.data.packages.forEach((packageItem) => {
                        self.packageOptions.push({
                            id: packageItem.id,
                            text: packageItem.name,
                        });
                    });
                });
        },
        addMoreServiceItem() {
            this.totalServiceItems++;
            this.order.services.push({
                service_type: "service",
                service_id: "",
                package_id: "",
                tax: 20,
                discount: "",
                amount: "",
                labour_cost: "",
                discount_amount: 0,
                tax_amount: 0,
                total_amount: 0,
                total_with_tax: 0,
                service_name: "",
                select_service: null
            });
        },
        calculateServiceItemAmount(type, index) {
            let self = this;
            let serviceDetail = {};
            if (type == "service") {
                // Get the service detail
                serviceDetail = self.services.find(
                    (service) =>
                        service.id == self.order.services[index].service_id
                );
            } else if (type == "package") {
                serviceDetail = this.packages.find(
                    (servicePackage) =>
                        servicePackage.id ==
                        this.order.services[index].package_id
                );
            }

            // Check if serviceDetail is not empty then update the amount in order.services
            let amount = 0;
            let LabourCost = 0;
            if (Object.keys(serviceDetail).length > 0) {
                amount = serviceDetail.price;
                LabourCost = serviceDetail.labour_cost;
            }

            this.order.services[index].amount = amount;
            this.order.services[index].labour_cost = LabourCost;
            this.order.services[index].total_amount = amount;
            this.order.services[index].total_with_tax = amount;
        },
        calculateServiceTotalAmount(service) {
            // Calculate total amount for each service considering discount
            const amount = Number(service.amount) || 0;
            const LabourCost = Number(service.labour_cost) || 0;
            const discountPercentage = Number(service.discount) || 0;
            const amountWithLabour = amount + LabourCost;
            const discount = (amountWithLabour * discountPercentage) / 100;

            // Get discount on the item price
            let itemDiscount = (amount * discountPercentage) / 100;

            // Get the discount on the labour
            let itemLabourDiscount = (LabourCost * discountPercentage) / 100;

            // Get the item price, labour price and final price after discount
            let itemTotalAmount = amount - itemDiscount;
            let itemLabourTotalAmount = LabourCost - itemLabourDiscount;
            let discountedAmount = amountWithLabour - discount;

            // Apply the 20% vat on the discounted amount
            let taxRate = service.tax;
            const taxAmount = (discountedAmount * taxRate) / 100;

            // Get the final amount
            let totalWithTax = discountedAmount + taxAmount;

            // Update the service tax amount in the order object
            service.tax_amount = parseFloat(taxAmount).toFixed(2);
            service.discount_amount = parseFloat(discount).toFixed(2);
            service.total_amount = parseFloat(discountedAmount).toFixed(2);
            service.total_with_tax = parseFloat(totalWithTax).toFixed(2);

            return {
                itemTotalAmount: isNaN(itemTotalAmount) ? 0 : itemTotalAmount,
                itemLabourTotalAmount: isNaN(itemLabourTotalAmount) ? 0 : itemLabourTotalAmount,
                finalAmount: isNaN(discountedAmount) ? 0 : discountedAmount,
            };
        },
        calculateServiceTotalDiscount(service) {
            // Calculate total discount for each service
            const amount = Number(service.amount) || 0;
            const LabourCost = Number(service.labour_cost) || 0;
            const discountPercentage = Number(service.discount) || 0;
            const amountWithLabour = amount + LabourCost;
            return (amountWithLabour * discountPercentage) / 100;
        },
        calculateTotalAmount() {
            // Calculate total amount for all services
            let totalAmount = 0;
            let totalItemAmount = 0;
            let totalLabourCost = 0;

            this.order.services.forEach((service) => {
                let serviceTotal = this.calculateServiceTotalAmount(service);

                totalItemAmount += parseFloat(serviceTotal.itemTotalAmount) || 0;
                totalLabourCost += parseFloat(serviceTotal.itemLabourTotalAmount) || 0;
                totalAmount += parseFloat(serviceTotal.finalAmount) || 0;
            });

            // Get the overall discount
            const discountPercentage = Number(this.order.discount) || 0;
            const discount = (totalAmount * discountPercentage) / 100;
            const discountedAmount = totalAmount - discount;

            // Apply the 20% vat on the discounted amount
            const vat = (discountedAmount * this.order.tax) / 100;
            let finalAmount = discountedAmount + vat;

            // Place only two decimal places
            totalAmount = parseFloat(totalAmount).toFixed(2);
            finalAmount = parseFloat(finalAmount).toFixed(2);

            // Update the total amount in the order object
            this.order.amount = totalAmount;
            this.order.item_price = isNaN(totalItemAmount) ? 0 : parseFloat(totalItemAmount).toFixed(2);
            this.order.labour_cost = isNaN(totalLabourCost) ? 0 : parseFloat(totalLabourCost).toFixed(2);
            this.order.discount_amount = isNaN(discount) ? 0 : parseFloat(discount).toFixed(2);
            this.order.tax_amount = isNaN(vat) ? 0 : parseFloat(vat).toFixed(2);
            this.order.total_amount = finalAmount;
        },
        validateInput(type, index) {
            // Ensure the entered value is not greater than 100
            if (type === "service") {
                if (this.order.services[index].discount > 100) {
                    this.order.services[index].discount = 100;
                }
            } else if (type === "order") {
                if (this.order.discount > 100) {
                    this.order.discount = 100;
                }
            }
        },
        allowNumbersOnly(event) {
            // Allow only numeric input
            const charCode = event.charCode;
            // allow only number keys and numpad number keys
            if (
                (charCode >= 48 && charCode <= 57) || // Regular number keys
                (charCode >= 96 && charCode <= 105) // Numpad number keys
            ) {
                return;
            }
        },
        handleSpecialKeys(event) {
            // Handle special keys like arrow keys, delete, and backspace
            const specialKeys = [8, 9, 46, 37, 39, 110,190];
            if (
                specialKeys.includes(event.keyCode) ||
                (event.keyCode >= 48 && event.keyCode <= 57) ||
                (event.keyCode >= 96 && event.keyCode <= 105)
            ) {
                return;
            }
            event.preventDefault();
        },
        // Create order
        async createOrder() {
            let self = this;

            //if (!this.validateOrderForm()) {
            //    this.isValidated = false;
            //    return;
            //}
            this.isValidated = await this.validateOrderForm();
            // Check if the form is validated
            if (!this.isValidated) {
                return;
            }

            this.isValidated = true;

            this.isProcessing = true;

            const config = {
                headers: { "content-type": "multipart/form-data" },
            };
            this.order.order_id = this.orderDetails.id;

            // Check if order comment is empty then set it to 'Order services has been updated.'
            if (this.order.comment == '') {
                this.order.comment = 'Order has been updated.'
            }

            this.order.access_arrangement = this.orderDetails.access_arrangement;
            this.order.special_note = this.orderDetails.special_note;

            this.order.action_type = 'order_updated';
            this.order.action = 'order_updated';
            this.order.services = this.order.services.map((item) => ({
                                    order_item_type : item.service_type,
                                    service_id : item.service_id,
                                    service_package_id : item.package_id,
                                    order_item_tax: item.tax,
                                    order_item_discount_value: item.discount,
                                    order_item_price: item.amount,
                                    order_item_labour_cost: item.labour_cost,
                                    order_item_total_amount: item.total_amount,
                                    order_item_id: item.order_item_id || 0,
                                    service_name: item.service_name,
                                    select_service: item.select_service
                                }));

            // Get the selected files from the image uploader
            // Check if files are available in the image uploader
            // Then iterate the files and push it to the order.files array
            if (this.$refs.imageUploader.files.length > 0) {
                this.$refs.imageUploader.files.forEach((file) => {
                    this.order.files.push(file.file);
                });
            }

            axios.post("/admin/orders/update-order", this.order, config)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.$notification('success', 'Order updated successfully');
                    }
                    this.getOrderDetails();
                    this.isProcessing = false;

                    // Reset the image uploader
                    this.$refs.imageUploader.clearFiles();

                    // Reset the files array
                    this.order.files = [];

                    // Reinitialize the image slider
                    this.attachImageSlider();
                })
                .catch((error) => {
                    this.isProcessing = false;
                    this.$notification('error', error.response.data.message);
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        },
        setMinDatetime() {
            // Set the minimum datetime
            this.minDatetime = moment().format("YYYY-MM-DDTHH:mm");
        },
        setMinDate() {
            this.minDate = moment().format("YYYY-MM-DD");
        },
        // Validate form, check all required fields are filled
        async validateOrderForm() {
            let isValidated = true;
            // Iterate the services and check if select_service is null then set isValidated to false
            for (let i = 0; i < this.order.services.length; i++) {
                if(this.order.services[i].select_service == null) {
                    isValidated = false;
                }
            }

            return isValidated;
        },
        onFileChange(event) {
            for (let file of event.target.files) {
                try {
                    let reader = new FileReader();
                    // Check the file type and adjust the processing accordingly
                    if (file.type.includes('image')) {
                        // Handle images
                        reader.onload = (e) => {
                            // Assuming `previewUploadedFiles` is meant to handle image previews
                            this.previewUploadedFiles.push({ file_name: e.target.result, extension: file.type, file_type: 'image', uploaded: true });
                        };
                        reader.readAsDataURL(file);
                    } else if (file.type.includes('video')) {
                        // Handle videos
                        reader.onload = (e) => {
                            // Assuming you want to store videos differently or not show previews
                            // Videos can be previewed by creating a video URL
                            const videoUrl = URL.createObjectURL(file);
                            // Assuming `previewUploadedFiles` is an array for storing video data
                            this.previewUploadedFiles.push({ file_name: videoUrl, extension: file.type, file_type: 'video' });
                        };
                        reader.readAsArrayBuffer(file); // We read videos as buffer since we don't need to display it as base64
                    } else if (file.type.includes('pdf')) {
                        // Handle PDFs and Documents
                        const docUrl = URL.createObjectURL(file);
                        this.previewUploadedFiles.push({ file_name: docUrl, extension: file.type, file_type: 'pdf' });
                    } else if(file.type.includes('msword') || file.type.includes('document')) {
                        const docUrl = URL.createObjectURL(file);
                        this.previewUploadedFiles.push({ file_name: docUrl, extension: file.type, file_type: 'document' });
                    } else if (file.type === 'application/zip') {
                        // Handle ZIP files
                        this.previewUploadedFiles.push({ file_name: file.name, extension: file.type, file_type: 'zip' });
                    }
                    this.order.files.push(file);
                } catch {}
            }
        },
        goBack() {
            //window.top.close();
            window.location.href = '/admin/orders';
        },
        prepareImageSource(imgObj) {
            if (imgObj.file_type === 'image') {
                // Check if call for recent uploaded file
                if (imgObj.uploaded) {
                    return imgObj.file_name;
                }
                else if (typeof imgObj.file_name !== 'undefined') {
                    return this.$s3RootUrl + "/order/" + imgObj.file_name;
                }
                else {
                    return this.$s3RootUrl + "/order/" + imgObj.image;
                }
            }
            else if(imgObj.file_type === 'video') {
                return this.$baseUrl + "/images/svg/file-video.svg";
            }
            else if(imgObj.file_type === 'zip') {
                return this.$baseUrl + "/images/svg/file-archive.svg";
            }
            else if(imgObj.file_type === 'pdf') {
                return this.$baseUrl + "/images/svg/file-pdf.svg";
            }
            else {
                return this.$baseUrl + "/images/svg/file-text.svg";
            }
        },
        attachImageSlider() {
            this.$nextTick(() => {
                //Get the order images and attach the lightbox orderImagesForSlider
                this.orderDetails.order_images.forEach((image) => {
                    this.orderImagesForSlider.push(this.$s3RootUrl + "/order/" + image.image);
                })

                // Slider for order images
                this.showSlider('.order-img-slides');

                // Slider for order history images
                this.showSlider('.order-history-img-slides');
            });
        },
        showSlider(selector) {
            GLightbox({
                selector: selector,
                touchNavigation: true,
                loop: false,
                autoplayVideos: false,
                plyr: {
                    config: {
                        controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen', 'download'],
                        settings: ['loop', 'quality', 'speed'],
                        speed: {
                            selected: 1,
                            options: [0.5, 0.75, 1, 1.25, 1.5, 2]
                        },
                        quality: {
                            default: 576,
                            options: [1080, 720, 576]
                        },
                        loop: { active: false }
                    }
                }
            });
        },
        onHideSlider() {
        },
        // Get the order ticket
        getOrderTicket() {
            axios.post(this.$baseUrl + "/admin/tickets/order-ticket", {
                order_id: this.orderDetails.id,
            })
                .then((response) => {
                    this.orderTicket = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addNewService(newService, index) {
            let serviceTag = {
                id: '',
                name: newService,
                price: 0.00,
                labour_cost: 0.00,
                discount: ''
            };
            this.serviceOptions.push(serviceTag);
            this.services.push(serviceTag);

            this.order.services[index].service_name = newService;
            this.order.services[index].select_service = serviceTag;
        },
        selectService(event, index) {
            //this.calculateServiceItemAmount('service', item - 1)
            this.order.services[index].service_id = event.id || '';
            this.order.services[index].name = event.name || '';
            this.order.services[index].service_name = event.name || '';
            this.order.services[index].amount = event.price ? event.price.toFixed(2) : 0;
            this.order.services[index].labour_cost = event.labour_cost ? event.labour_cost.toFixed(2) : '';
            this.order.services[index].discount = event.discount || '';
        },
        async copyToClipboard(textToCopy) {
            try {
                await navigator.clipboard.writeText(textToCopy);
                this.$notification('success', 'Copied to clipboard');
            } catch (error) {
                this.$notification('error', 'Failed to copy to clipboard');
            }
        },
        async getHandymanAvailable() {
            // Parse the time string to get hours and minutes
            const [hours, minutes] = this.order.booking_time.split(':').map(Number);

            let params = {
                order_id: this.orderDetails.id,
                booking_date: this.order.booking_date,
                start_time: { hours, minutes },
                end_time: { hours: hours + 1, minutes },
            };
            let users = await this.getHandymanForTaskAssignment(params);

            //Check if user is empty then empty the handyman_ids
            if (users.length == 0) {
                this.order.handyman_ids = [];
            }
            //Prepare the options
            this.handymanList = users.map(user => ({
                id: user.id,
                text: user.name,
                name: user.name,
            }));
        },
        removeOrderImage(orderImage) {
            // Before remove the image display the confirmation modal
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#198754',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    //this.orderDetails.order_images.splice(index, 1);

                    // Remove the image from the server
                    axios.post(this.$baseUrl + "/api/admin/orders/remove-attachment", {
                        order_id: this.orderDetails.id,
                        file_id: orderImage.id,
                    })
                        .then((response) => {
                            this.$notification('success', response.data.message);

                            // Refresh the order details
                            this.getOrderDetails();
                        })
                        .catch((error) => {
                            this.$notification('error', error.response.data.message);
                        });
                }
            });
        },
        isAttachmentDeleted(attachmentId) {
            // Check if the attachment is deleted
            return this.orderDetails.order_images.findIndex((image) => image.id == attachmentId) == -1;
        }
    },
    watch: {
        "order.services": {
            handler(newServices, oldServices) {
                // Recalculate the total amount and total discount for all services
                this.calculateTotalAmount();
            },
            deep: true,
        },
        "order.discount": function (newDiscount, oldDiscount) {
            // Recalculate the total amount for all services
            this.calculateTotalAmount();
        },
        // When change the TAX amount
        "order.tax": function (newTax, oldTax) {
            // Recalculate the total amount for all services
            this.calculateTotalAmount();
        },
    },
};
</script>
